import React from 'react';
import '../styles/LanguageToggle.css';

const LanguageToggle = ({ currentLang, onToggle }) => {
    return (
        <button className="lang-toggle" onClick={onToggle}>
            <span className="lang-text">
                {currentLang === 'ar' ? 'English' : 'العربية'}
            </span>
        </button>
    );
};

export default LanguageToggle;

